import axios from '@/plugins/axios';
import {
  ROLES_THAT_REGISTER_LOCATION,
  ROLES_THAT_SEND_NULL_CHANNEL,
  EMPLOYEE_LOCATION_EVENT_TYPE,
} from '@/core/constants/geolocation/employeeLocation';
import { checkGeolocationStatus } from '@/utilities/geolocation';

export async function registerLoginLocation({ employeeNumber, role, channel }) {
  try {
    if (!role || !ROLES_THAT_REGISTER_LOCATION.includes(role.name)) return;

    const { allowed, coords } = await checkGeolocationStatus();
    if (!allowed || !coords) return;

    await axios.post('/employee/location', {
      employee_code: employeeNumber,
      latitude: coords.lat,
      longitude: coords.lng,
      channel: ROLES_THAT_SEND_NULL_CHANNEL.includes(role.name)
        ? null
        : channel,
      role_id: role.id,
      type: EMPLOYEE_LOCATION_EVENT_TYPE.LOGIN,
    });
  } catch {
    // ERRORS ARE SILENT, OTHERWISE IT WILL BLOCK THE LOGIN
  }
}
